import { render } from "./Motivation.vue?vue&type=template&id=33f2f88c"
import script from "./Motivation.vue?vue&type=script&lang=ts"
export * from "./Motivation.vue?vue&type=script&lang=ts"
script.render = render

export default script